import { render, staticRenderFns } from "./abnormalType.vue?vue&type=template&id=12f7416a&scoped=true&"
import script from "./abnormalType.vue?vue&type=script&lang=js&"
export * from "./abnormalType.vue?vue&type=script&lang=js&"
import style0 from "./abnormalType.vue?vue&type=style&index=0&id=12f7416a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f7416a",
  null
  
)

export default component.exports